export enum PaymentStatus {
  Success = 'Success',
  Error = 'Error',
  Cancel = 'Cancel',
}
